module.exports = __webpack_public_path__ + "static/assets/27167239910c66c4033316c7862e6f40.svg";